import { translate } from 'hooks/translation/useTrls';

import { FilterItem, FILTERS, FILTERS_RECEIVED_AS_OBJECT } from 'components/Dashboard/Filters/consts';

import { AppliedFilters, FilterName, FiltersList, FilterValues } from 'store/models/dashboard';
import { Trls } from 'store/models/translations';

// eslint-disable-next-line import/prefer-default-export
export const calculateFiltersCount = (chosenFilters: AppliedFilters): number => {
    return Object.values(chosenFilters).reduce(
        (count: number, values: string[]) => (values.length > 0 ? count + values.length : count),
        0
    ) as number;
};

/**
 * Получает на вход имя фильтра, например moderationStatuses и список значений фильтра, например ['IN_PROCESS', 'FAILED']
 * Возвращает массив фильтров формата { id: string; name: string; tip?: string; } забирая значения из словаря
 * areas бэкенд присылает вместе с переводами
 */
const processFilterValues = (trls: Trls, filterName: FilterName, filterValues: FilterValues): FilterItem[] => {
    if (Array.isArray(filterValues) && !FILTERS_RECEIVED_AS_OBJECT.includes(filterName)) {
        return filterValues.map((value) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const filter = FILTERS[filterName][value] as FilterItem;
            return {
                id: filter.id,
                name: translate(trls, filter.name),
                ...(filter.tip ? { tip: translate(trls, filter.tip) } : {}),
            };
        });
    }
    if (FILTERS_RECEIVED_AS_OBJECT.includes(filterName) && typeof filterValues === 'object') {
        return Object.entries(filterValues).map(([id, name]) => ({ id, name }));
    }
    return [];
};

const isEmptyFilter = (filterValues: FilterItem[]): boolean => {
    return !filterValues || filterValues.length === 0;
};

/**
 * Позволяет получить объект вида
 * { budgetStatuses: [
 *    {
 *      id: 'EXHAUSTED',
 *      name: 'Dashboard.Filters.Filter.BudgetState.exhausted'
 *    }
 *  ],
 *  areas: [
 *    {
 *      id: '2',
 *      name: 'Москва'
 *    }
 *  ],
 *  }
 */
export const getFilters = (trls: Trls, filtersList: FiltersList): Record<FilterName, FilterItem[]> => {
    const processedFilters: [FilterName, FilterItem[]][] = Object.entries(filtersList).map(
        ([filterName, filterValues]) => [
            filterName as FilterName,
            processFilterValues(trls, filterName as FilterName, filterValues),
        ]
    );

    const notEmptyFilters: [FilterName, FilterItem[]][] = processedFilters.filter(
        ([, filterValues]) => !isEmptyFilter(filterValues)
    );

    return Object.fromEntries(notEmptyFilters) as Record<FilterName, FilterItem[]>;
};
